import { render, staticRenderFns } from "./_Dashboard1.vue?vue&type=template&id=ac365d36&scoped=true"
import script from "./_Dashboard1.vue?vue&type=script&lang=js"
export * from "./_Dashboard1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac365d36",
  null
  
)

export default component.exports